/**
 * Resul list JS controller.
 *
 * This class handles the load more and filtering
 * of items on different search result views and list pages.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class ResultList. This gets mapped with the keyword ResultList and its
 * docready method is fired automatically on pages where there's a
 * class called 'ResultList' on the html tag.
 */
class ResultList {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the methods
     */
    cache() {

        // The button that removes filters.
        this.removeFiltersBtn = $( '#js-remove-filters' );

        // The category filters.
        this.categoryFilters = $( '.js-category-filter' );

        // The time filters.
        this.timeFilters = $( '.js-time-filter' );

        // The first caching of all results before hiding anything.
        this.listItems = $( '.js-result-item' );

        // The disclaimer that is shown if there's no items
        this.noItemsFound = $( '#js-no-items' );

        // Get search filters for screen readers to be read with aria live - create an empty array to push them into
        this.srFiltersContainer = $( '#js-screenreader-filters' );
        this.srCategoryFiltersContainer = $( '#js-screenreader-categoryfilters' );
        this.srYearFiltersContainer = $( '#js-screenreader-yearfilters' );
        this.srMonthFiltersContainer = $( '#js-screenreader-monthfilters' );
        this.srFiltersRemovedContainer = $( '#js-screenreader-filtersremoved' );
        this.srCategoryFilters = [];
        this.srTimeFilters = [];

        // Strings to populate screenreader filter descriptions
        this.srCategory =  themeData.themeStrings.sr_archive_filters.active_filters;
        this.srMonth =  themeData.themeStrings.sr_archive_filters.filters_month;
        this.srYear =  themeData.themeStrings.sr_archive_filters.filters_year;
        this.srFiltersRemoved =  themeData.themeStrings.sr_archive_filters.filters_removed;

        // The load more button is shown if there is more items
        // to show than the value of 'this.postsPerPage'.
        this.loadMoreBtn            = $( '.js-load-more' );
        this.loadMoreContainer      = $( '.js-load-more-container' );
        this.loadMoreOriginalOffset = this.loadMoreBtn.attr( 'data-offset' );

        // The pagination setting for the load more functionality.
        // This many items are shown at first and revealed on each load more click.
        this.postsPerPage = 12;

        this.categoryFiltersWrapper = $( '#js-category-filters' );
        this.timeFiltersWrapper     = $( '#js-time-filters' );
        this.removeFiltersWrapper   = $( '#js-remove-filters-wrapper' );

        // For focusing on screenreaders
        this.loadMoreClicked = false;
        this.nextFocusable = this.postsPerPage;

    }

    /**
     * All dom events of the class.
     * @return {void}
     */
    events() {

        // Loop through each of the category filters and bind a click handler to each of them.
        this.categoryFilters.each( ( index, categoryFilter ) => {

            $( categoryFilter ).on( 'click', ( e ) =>  {

                // Format the value of the offset back to the initial value
                // when the filter changes.
                this.loadMoreBtn.attr( 'data-offset', this.loadMoreOriginalOffset );

                // Toggle the active class of each clicked filter and
                // Call the filtering method.
                categoryFilter.classList.toggle( 'js-active' );
                this.filterResults( e );

                // Add to screenreaders
                this.filtersForScreenreaders( categoryFilter, 'categories', false );

            });

        });

        // Loop through each of the time filters and bind a click handler to each of them.
        this.timeFilters.each( ( index, timeFilter ) => {

            $( timeFilter ).on( 'change', ( e ) =>  {

                // Format the value of the offset back to the initial value
                // when the filter changes.
                this.loadMoreBtn.attr( 'data-offset', this.loadMoreOriginalOffset );

                const $timeFilter = $( timeFilter );
                $timeFilter.removeClass( 'js-active' );

                // Only set the filter's state as active if the value
                // not 'all'.
                if ( $timeFilter.val() !== 'all' ) {
                    $timeFilter.addClass( 'js-active' );
                }

                this.filterResults( e );

                // Add to screenreaders
                const timetype = $( timeFilter ).attr( 'name' );
                this.filtersForScreenreaders( $timeFilter, 'times', timetype );

            });

        });

        // Bind a handler on the filter removing button click.
        this.removeFiltersBtn.on( 'click', e => this.removeFilters( e ) );

        // Bind a handler to the load more button click event.
        // this.loadMoreBtn.on( 'click', e => this.loadMore( e ) );
        this.loadMoreBtn.on( 'click', ( e ) => {
            this.loadMoreClicked = true;
            this.loadMore( e );
        });
    }

    /**
     * Function to give screenreaders all the active filters. # -elements
     * instead of cached ones, because this function uses a clone of the original element
     * @param {string} srFilter
     * @param {string} target
     * @param {string} timetype
     */
    filtersForScreenreaders( srFilter, target, timetype ) {

        // Empty the 'filters removed' string
        $( '#js-screenreader-filtersremoved' ).html( '' );

        // Create a clone of ARIA Contents to be modified
        const clone = $( '#js-screenreader-filters' ).clone();

        // Check if the filter is a category
        if ( target == 'categories' ) {

            // Get current filter
            const currentFilter = $( srFilter ).text();

            // Set the clones filters wrap in a const for code readability
            const cloneCategoryFilters = clone.find( '#js-screenreader-categoryfilters' );

            // Check if current filter is already in the array
            if ( $.inArray( currentFilter, this.srCategoryFilters ) > -1 ) {

                // Splice array to get rid of current filter
                this.srCategoryFilters.splice( $.inArray( currentFilter, this.srCategoryFilters ), 1 );

                // Check if array is not empty after splice. If not, show it.
                if ( $( this.srCategoryFilters ).length ) {

                    // Build a string to show to screen readers
                    const categoryFiltersString =  this.srCategory + ': ' + this.srCategoryFilters.join( ', ' ) + '.';

                    // Assign the built string for screen readers
                    cloneCategoryFilters.html( categoryFiltersString );

                } else {
                    cloneCategoryFilters.html( '' );
                }

            // If the current filter is not in the array, push it there
            } else {
                this.srCategoryFilters.push( currentFilter );

                // Build a string to show to screen readers
                const categoryFiltersString =  this.srCategory + ': ' + this.srCategoryFilters.join( ', ' ) + '.';

                // Assign the built string for screen readers
                cloneCategoryFilters.html( categoryFiltersString );
            }

        // If the filter is not a category, its related to time
        } else {

            // Set selected filter to const and its value to another one
            const currentFilter = srFilter;
            const currentFilterValue = srFilter.val();

            // Set the clones filters wrap in a const for code readability
            const cloneTimeFiltersYear = clone.find( '#js-screenreader-yearfilters' );
            const cloneTimeFiltersMonth = clone.find( '#js-screenreader-monthfilters' );

            // Check if it's a year & check if it's filtered or not
            if ( timetype == 'year' ) {

                // Check if filter is a year. Check if filter is set or not.
                if ( currentFilterValue != 'all' ) {

                    // Build a string to show to screen readers
                    const yearFiltersString =  this.srYear + ': ' + currentFilterValue + '.';

                    // Assign the built string for screen readers
                    cloneTimeFiltersYear.html( yearFiltersString );

                } else {

                    // If value of year is all, clear filter
                    cloneTimeFiltersYear.html( '' );
                }

            // If it's not a year, its a month
            } else {

                // Check if value is 'all', if not, then get the text value of the selected item
                if ( currentFilterValue == 'all' ) {

                    // If value of month is all, clear filter
                    cloneTimeFiltersMonth.html( '' );

                } else {

                    // Get the text value of the selected option
                    const currentFilterText = currentFilter.find( 'option:selected' ).text();

                    // Build a string to show to screen readers
                    const monthFiltersString = this.srMonth + ': ' + currentFilterText + '.';

                    // Assign the built string for screen readers
                    cloneTimeFiltersMonth.html( monthFiltersString );

                }
            }
        }

        // Remove and repopulate filters on change
        $( '#js-filters-aria-paragraph' ).remove();
        $( this.srFiltersContainer ).html( clone.html() );
    }

    /**
     * This hides the items and shows the filters when javascript is loaded. Otherwise
     * users can see them all and there's no need for filters.
     */
    a11y() {

        this.listItems.each( ( index, item ) => {
            item.classList.add( 'js-hidden' );
        });

        this.categoryFiltersWrapper.removeClass( 'js-hidden' );
        this.timeFiltersWrapper.removeClass( 'js-hidden' );
        this.removeFiltersWrapper.removeClass( 'js-hidden' );
    }

    /**
     * This checks for a URL parameter and set the corresponding category
     * filter as active.
     */
    initialLoad() {

        const categorySlugFromUrl = Theme.Common.getUrlParameter( 'cat' );

        this.categoryFilters.each( ( index, filter ) => {

            // Check if the filter is active.
            if ( filter.dataset.categoryslug === categorySlugFromUrl ) {
                filter.classList.add( 'js-active' );
            }

        });

        this.filterResults();
    }


    /**
     * This removes all filters and resets the results.
     */
    removeFilters( e ) {

        Theme.Common.stop( e );

        this.categoryFilters.each( ( index, filter ) => {

            filter.classList.remove( 'js-active' );

        });

        this.timeFilters.each( ( index, filter ) => {

            const $filter = $( filter );
            $filter.removeClass( 'js-active' );
            $filter.val( 'all' );
        });

        this.filterResults();

        // For code readability and debugging: create consts of filters removed wrap and
        // its siblings
        const srFiltersRemoved = $( '#js-screenreader-filtersremoved' );
        const srFiltersRemovedSiblings = $( '#js-screenreader-filtersremoved' ).siblings();

        // Empty also the filter list for screen readers
        srFiltersRemoved.html( this.srFiltersRemoved );
        srFiltersRemovedSiblings.html( '' );
        this.srCategoryFilters  = [];
        this.srTimeFilters  = [];

    }

    /**
     * With this method we make changes in the result items
     * when the filters are clicked.
     *
     * @param {event object} e
     */
    filterResults( e = false ) {

        if ( e ) {

            // Stop the event with the static method from the Common class.
            Theme.Common.stop( e );
        }

        // The items have two classes; selected and active. The selected class
        // Indicates that items are selected with a filter to be shown and the active
        // class shows them according to simple 'pagination' rules.

        // Remove the 'selected' class and the active class from every item.
        this.listItems.removeClass( 'js-result-selected--cat' );
        this.listItems.removeClass( 'js-result-selected--time' );
        this.listItems.removeClass( 'js-result-active' );

        const activeCatFilters = [];
        const activeTimeFilters = {
            'year': false,
            'month': false
        };

        // Loop through the filters and check which ones are active.
        // Add active filters to an array and use it later on.
        this.categoryFilters.each( ( index, filter ) => {

            // Check if the filter is active.
            if ( filter.classList.contains( 'js-active' ) ) {

                // Get the tag from the filter button's data-attribute 'categoryid'.
                const filterID  = filter.dataset.categoryid;
                activeCatFilters.push( filterID );
            }
        });

        // Loop through time filters and check which ones are active.
        // Add active filters to an array and use it later on.
        this.timeFilters.each( ( index, filter ) => {

            // Check if the filter is active.
            if ( filter.classList.contains( 'js-active' ) ) {

                if ( $( filter ).attr( 'name' ) == 'year' ) {
                    activeTimeFilters.year = $( filter ).val();
                } else {
                    activeTimeFilters.month = $( filter ).val();
                }
            }
        });

        // Loop through all items.
        this.listItems.each( ( index, listItem ) => {

            // Store the comma-separated list of the items' categories.
            // Each item can have more than one.
            const itemCategories = listItem.dataset.category;

            // Store the time values
            const itemYear  = listItem.dataset.year;
            const itemMonth = listItem.dataset.month;

            // If category filters are selected, check the items for corresponding
            // categories. Otherwise don't filter by category.
            if ( activeCatFilters.length > 0 ) {

                // If the item has a category or categories, make an array of them
                // and check if active categories match the item's categories.
                if ( typeof itemCategories !== 'undefined' ) {

                    const itemCategoriesArray = itemCategories.split( ',' );

                    activeCatFilters.forEach( ( category ) => {

                        if ( itemCategoriesArray.indexOf( category ) > -1 ) {

                            listItem.classList.add( 'js-result-selected--cat' );
                        }

                    });
                }
            } else {
                listItem.classList.add( 'js-result-selected--cat' );
            }

            /**
             * Here we construct the logic for time filtering. If
             * the filters are both active check that items have both corresponding values.
             * If only one filter is active, the items only need to have that corresponding value.
             * If both filters are inactive, don't filter items by time.
             */
            let timeSelected = false;

            if ( activeTimeFilters.year == false && activeTimeFilters.month == false ) {

                timeSelected = true;

            } else {

                if ( typeof itemYear !== 'undefined' && typeof itemMonth !== 'undefined' ) {

                    if ( activeTimeFilters.year == itemYear || activeTimeFilters.month == itemMonth ) {

                        timeSelected = true;

                        if ( activeTimeFilters.year && activeTimeFilters.month ) {

                            timeSelected = false;

                            if ( activeTimeFilters.year == itemYear && activeTimeFilters.month == itemMonth ) {
                                timeSelected = true;
                            }
                        }
                    }
                }
            }

            if ( timeSelected ) {
                listItem.classList.add( 'js-result-selected--time' );
            }

        });


        // This reveals the first 'page' -subset of the filtered items
        // and shows the load more -button if needed.
        this.revealSelected( this.postsPerPage );
    }

    /**
     * The load more method. First, this method gets the data
     * from the load more -button and calls the 'revealSelected' method with
     * that data. Then it updates the clicked amount / offset of the subsets to
     * be shown with the next load more click.
     *
     * @param {event object} e
     */
    loadMore( e ) {

        // Stop the event with the static method from the Common class.
        Theme.Common.stop( e );

        // The target object of the clicked load more button
        // and the data from its data-attributes.
        const target        = e.target;
        let offset          = +target.dataset.offset;

        // The current set of items to reveal on each click.
        // On the first load the set amount is two.
        // This grows by one after each click and the default
        // item subset amount gets multiplied with it.
        const currentSet    = offset * this.postsPerPage;

        // Call the actual method that reveals the item subset.
        this.revealSelected( currentSet );

        // Grow the offset by one and set it back in to the buttons data in the DOM.
        target.dataset.offset = ++offset;
    }

    /**
     * The method that does the actual revealing of
     * the 'next subset' of items in the load more functionality.
     *
     * @param {int} numToReveal
     */
    revealSelected( numToReveal ) {

        /**
         * First, the currently selected set of items are counted
         * and the active class of the load more button is removed.
         */
        const selectedItems = this.getSelectedItems();
        const numOfSelectedItems = selectedItems.length;
        this.loadMoreContainer.removeClass( 'js-active' );
        this.noItemsFound.removeClass( 'js-active' );

        // Show text if no items are found.
        if ( numOfSelectedItems == 0 ) {
            this.noItemsFound.addClass( 'js-active' );
        }

        /**
         * Then, if the amount of items to be revealed (numToReveal)
         * is smaller than the actual set of items, we add the active
         * class back to the button. Otherwise we know that there isn't any more
         * to load. If the amount is larger, we set the amount to the actual amount of the items.
         */
        if ( numToReveal >= numOfSelectedItems ) {
            numToReveal = numOfSelectedItems;
        } else {
            this.loadMoreContainer.addClass( 'js-active' );
        }

        /**
         * Then we slice the amount of items to reveal to a new array and
         * remove the active class of the currently selected set of items.
         *
         * Then we loop through the items in the new array and add an active
         * class to each. This way it looks like we loaded a new subset of items,
         * even though we hid all subsets and then showed a larger subset
         * of items. The subset incrementation happens in the load more method.
         */
        const nextItemsToShow = selectedItems.slice( 0, numToReveal );

        selectedItems.removeClass( 'js-result-active' );

        nextItemsToShow.each( ( index, item ) => {
            item.classList.add( 'js-result-active' );
        });

        // Focus on the next loaded item - with a small delay
        if ( this.loadMoreClicked == true ) {
                setTimeout( () => {

                    // At this point nextFocusable is the number of posts per page
                    this.nextFocusable = this.nextFocusable;

                    // Focus on the next shown item
                    $( nextItemsToShow[this.nextFocusable ]).attr( 'tabindex', '-1' ).focus();

                    // then double it to match the number of shown posts now
                    this.nextFocusable = this.nextFocusable * 2;

                }, 500 );
            }
    }

    /**
     * This returns all items that currently have the selected classes.
     */
    getSelectedItems() {

        return $( '.js-result-selected--cat.js-result-selected--time' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        this.cache();
        this.a11y();
        this.initialLoad();
        this.events();
    }

}

// Export the class reference.
module.exports = ResultList;



// WEBPACK FOOTER //
// ./assets/scripts/resultlist.js